import React from "react";
import Layout from "../../components/Layout";
import "./OffshoreMedicine.css";
import image from "../../images/1.png";
import InfoCard from "src/components/InfoCard";

const OffshoreMedicine: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"Offshore Medicine"} image={image}>
        <div className="offshore-details">
          <p>
            Oil & Gas UK / Offshore Energies UK is the voice of the offshore
            industry. It is the leading representative body for the UK offshore
            oil & gas industry. Its aim is to strengthen the long-term health of
            the offshore oil & gas industry in the United Kingdom by working
            closely with companies across the sector, governments, and all other
            stakeholders to address the issues that affect your business. We are
            certified medical providers for OGUK/OEUK (Oil and Gas UK Physios)
            also called UKOOA (United Kingdom Offshore Operators Association
            Physicals).
          </p>
          <p>
            <strong>OGUK/OEUK - Standard Offshore Medical:</strong>
            <br></br>
            This is the standard offshore medical fitness assessment which is
            required for all offshore workers. Appointment is booked for 60
            minutes. You will need to present valid form of identity as
            Passport.
          </p>
          <p>
            <strong>OGUK/OEUK - Fitness To Train Medical - FTT:</strong>
            <br></br>
            This is an additional OGUK/OEUK fitness certificate which is
            required for survival course trainees for in-water training
            exercises with compressed-air emergency breathing apparatus (EBS).
            This assessment will classify trainees as either 'fit' or 'unfit'
            for in-water EBS training as simply as possible. It is understood
            that workers assessed unfit for in-water EBS training will likely be
            permitted to complete survival training by dry EBS training
            exercises only. This is a 60 min appointment.
          </p>
          <p>
            <strong>
              OGUK/OEUK - Emergency Response Team Duties -<br></br>
              ERT (Includes Chester Step Test):
            </strong>
            <br></br>
            This is an additional OGUK/OEUK fitness certificate required for
            Emergency Response Team members. A higher level of fitness is
            required for this role to fulfill a range of duties including
            firefighting, assisting with controlled platform evacuation and
            casualty search and rescue. This assessment takes 60 minutes.
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default OffshoreMedicine;
